export default class States {
	static NEW = 'NEW';
	static UPDATED = 'UPDATED';
	static DELETED = 'DELETED';
	static REFERENCE = 'REFERENCE';
};
